import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import Tabs from "../../../Components/Common/Tabs";
import { subChapterQuestionTabsData } from "../../../data/SidebarData";
import { faAdd, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import useToastError from "../../../hooks/useErrorToast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "../../../Components/Common/Modal";
import useSWRMutation from "swr/mutation";
import {
  subchapterQuestionUrls,
  subchapterUrls,
} from "../../../Api/Auth/ApiUrls";
import {
  sendPostRequestAuth,
  sendPutRequestAuth,
} from "../../../Api/swrConfig";
import { toast } from "react-toastify";
import useSWR from "swr";
import QueryString from "qs";
import useTable from "../../../hooks/useTable";
import QuestionForm from "./Components/QuestionForm";
import Storage from "../Storage";
import Table from "../../../Components/Common/Table";
import TableHead from "../../../Components/Common/TableHead";
import { Loader } from "../../../Components/Common/Loader";
import NoData from "../../../Components/Common/NoData";
import QuestionRow from "./Components/QuestionRow";
import Pagination from "../../../Components/Common/Pagination/Pagination";
import NotFound from "../../Notfound";
const tableColumnData = [
  { id: "no", label: "No" },
  { id: "questionText", label: "Question" },
  { id: "createdAt", label: "Created" },
];

const Questions = () => {
  const [row, setRow] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    No: null,
    questionText: "",
    questionImage: "",
    optionAImage: "",
    optionBImage: "",
    optionCImage: "",
    optionDImage: "",
    optionA: "",
    optionB: "",
    optionC: "",
    optionD: "",
    correctOptionIndex: null,
    solutionText: "",
    solutionImage: "",
    showFirst: false,
  });
  const [isModalOpen, setModalOpen] = useState(false);
  const [isStorageModalOpen, setStorageModalOpen] = useState(false);
  const [isAnswerStorageModalOpen, setAnswerStorageModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { showErrorToast } = useToastError();
  const { id } = useParams();

  const actionButtons = [
    {
      label: "Create",
      icon: faAdd,
      onClick: () => {
        setRow(null);
        setFormData({
          No: null,
          questionText: "",
          questionImage: "",
          optionAImage: "",
          optionBImage: "",
          optionCImage: "",
          optionDImage: "",
          optionA: "",
          optionB: "",
          optionC: "",
          optionD: "",
          correctOptionIndex: null,
          solutionText: "",
          solutionImage: "",
          showFirst: false,
        });
        setModalOpen(true);
      },
    },
    {
      label: "Back",
      icon: faArrowLeft,
      onClick: () => {
        navigate(-1);
      },
    },
  ];

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable({ defaultOrderBy: "" });
  const apiQueryParams = {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
    subChapter: id,
  };

  const onEditClick = (row, index) => {
    setRow({
      ...row,
      index: index,
    });
    handleInputChange("No", row.No);
    handleInputChange("questionText", row.questionText);
    handleInputChange("questionImage", row.questionImage);
    handleInputChange("optionAImage", row.optionAImage);
    handleInputChange("optionBImage", row.optionBImage);
    handleInputChange("optionCImage", row.optionCImage);
    handleInputChange("optionDImage", row.optionDImage);
    handleInputChange("optionA", row.options?.[0]);
    handleInputChange("optionB", row.options?.[1]);
    handleInputChange("optionC", row.options?.[2]);
    handleInputChange("optionD", row.options?.[3]);
    handleInputChange("correctOptionIndex", row.correctOptionIndex);
    handleInputChange("solutionText", row.solutionText);
    handleInputChange("solutionImage", row.solutionImage);
    handleInputChange("showFirst", row.showFirst ?? false);
    setModalOpen(true);
  };

  const apiQueryString = QueryString.stringify(apiQueryParams);

  const { isLoading, data, mutate, error } = useSWR(
    subchapterQuestionUrls.list(apiQueryString)
  );
  const { data: subChapterData } = useSWR(subchapterUrls.single(id));

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: name === "showFirst" ? value === "true" || value === true : value, // Convert string to boolean for showFirst
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    // if (!formData.questionText)
    //   newErrors.questionText = "Question text is required";
    // if (!formData.optionA) newErrors.optionA = "Option A is required";
    // if (!formData.optionB) newErrors.optionB = "Option B is required";
    // if (!formData.optionC) newErrors.optionC = "Option C is required";
    // if (!formData.optionD) newErrors.optionD = "Option D is required";
    if (!formData.correctOptionIndex)
      newErrors.correctOptionIndex = "Correct Option is required";
    // if (!formData.solutionText)
    //   newErrors.solutionText = "Solution Text is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const { trigger, isMutating } = useSWRMutation(
    subchapterQuestionUrls.create,
    sendPostRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );
  const { trigger: EditTrigger, isMutating: editMutating } = useSWRMutation(
    subchapterQuestionUrls.edit(row?._id),
    sendPutRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const options = [
      formData.optionA,
      formData.optionB,
      formData.optionC,
      formData.optionD,
    ];
    const updatedData = {
      ...formData,
      correctOptionIndex: formData.correctOptionIndex.value,
      options,
    };
    delete updatedData.optionA;
    delete updatedData.optionB;
    delete updatedData.optionC;
    delete updatedData.optionD;
    row
      ? EditTrigger(updatedData)
      : trigger({ ...updatedData, subChapter: id });
  };
  useEffect(() => {
    if (error?.message) {
      if (error.message === "Request failed with status code 400") {
        toast.error("Question Id is not valid");
      }
    }
  }, [error]);

  if (error?.message === "Request failed with status code 400") {
    return <NotFound />;
  }

  const chapterTitle = subChapterData?.subChapter?.chapter?.title;
  const subChapterTitle = subChapterData?.subChapter?.title;

  return (
    <div>
      <Breadcrumb
        actionButtons={actionButtons}
        noNavigate
        customBreadcrumb={[
          chapterTitle ? `Chapters(${chapterTitle})` : "Chapters",
          subChapterTitle ? `Subchapters(${subChapterTitle})` : "Subchapters",
        ]}
      />
      <Tabs tabs={subChapterQuestionTabsData} />
      <Table>
        <TableHead rowCount={data?.data.length} headerData={tableColumnData} />
        <tbody className={`divide-y divide-gray-200`}>
          {!isLoading ? (
            <>
              {data?.data.map((row, index) => (
                <QuestionRow
                  pagination={data?.pagination}
                  index={index}
                  length={data?.data?.length}
                  key={row._id}
                  row={row}
                  mutate={mutate}
                  onEditClick={onEditClick}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="100" className="text-center py-4">
                <Loader />
              </td>
            </tr>
          )}
        </tbody>
        <NoData isNotFound={!data?.data.length && !isLoading} />
      </Table>
      <Pagination
        totalRows={data?.pagination.totalItems || 0}
        currentPage={page}
        rowsPerPage={rowsPerPage}
        currentPath={location.pathname}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal
        isOpen={isModalOpen}
        title={
          row
            ? `Edit Question (${row?.index})`
            : `Create Question (${data?.data?.length + 1})`
        }
        onConfirm={handleSubmit}
        onCancel={() => {
          setErrors({});
          setModalOpen(false);
        }}
        isLoading={isMutating || editMutating}
      // formWidth="max-w-[600px]"
      >
        <QuestionForm
          errors={errors}
          handleSubmit={handleSubmit}
          onChange={handleInputChange}
          formData={formData}
        />
      </Modal>
      <Modal
        isOpen={isStorageModalOpen}
        title={"Storage Manager"}
        // onConfirm={handleSubmit}
        onCancel={() => {
          setStorageModalOpen(false);
        }}
        footer={false}
      >
        <Storage
          isSelector
          onConfirm={(file) => {
            if (Array.isArray(file) && file.length)
              handleInputChange("questionImage", file[0]?.fileUrl);
            setStorageModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        isOpen={isAnswerStorageModalOpen}
        title={"Storage Manager"}
        // onConfirm={handleSubmit}
        onCancel={() => {
          setAnswerStorageModalOpen(false);
        }}
        footer={false}
      >
        <Storage
          isSelector
          onConfirm={(file) => {
            if (Array.isArray(file) && file.length)
              handleInputChange("solutionImage", file[0]?.fileUrl);
            setAnswerStorageModalOpen(false);
          }}
        />
      </Modal>
    </div>
  );
};

export default Questions;
